// src/pages/Platform/PlatformAccessDenied.js
//
// AccessDenied.js's own Super Admin panel equivalent — same shape, but
// falls back to "/platform/companies" (this panel's own landing page)
// instead of the tenant app's "/dashboard", which a platform-staff member
// signed in here has no access to at all.
import { useNavigate, useLocation } from "react-router-dom";

export default function PlatformAccessDenied() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/platform/companies";

  return (
    <div style={{ textAlign: "center", padding: 50 }}>
      <h1>❌ Access Denied</h1>
      <p>You do not have permission to view this page.</p>
      <button
        onClick={() => navigate(from)}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          borderRadius: 6,
          border: "none",
          background: "#38bdf8",
          color: "#0f172a",
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Go Back
      </button>
    </div>
  );
}
